import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/AppHome.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/courses',
        name: 'Courses',
        component: () => import('../views/AppCourses.vue')
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/AppAbout.vue')
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 }
    }
})

export default router
